import React, {useState} from 'react'
import {Button, Form} from 'semantic-ui-react'
import Dialog from '../../dialog'
import useSWR, { mutate }  from 'swr'
import * as Yup from 'yup'
import {GlossaryFetcher, GlossarySave} from '../../../fetch/glossary'
//import {marginL10, marginB10, marginB30, spanDiv, spanGrey, spanTransparent, panelBox, marginB4, allElements, selectedElements} from "../../glossary/sidebar.module.scss"
//import classNames from 'classnames'
import {getApiResponseErrorMessage} from '../../error'
import {fieldNames, directions, periods, flowStatuses as statuses} from "../options"

const AppDataFlow = ({ id, open, loading, onSubmit, onClose, flow }) => {

    const initialState = {
        loading: false,
        direction: '',
        periodicity: '',
        source: '',
        status: '',
        //docLink: '',
        //technology: '',
        app: id,
        id: null
    }

    const [state, setState] = useState(initialState)
    const loadElements = React.useRef(true);
    const [dataApps, setDataApps] = useState(null);

    const { data : appList, errorApps } = useSWR(!loadElements.current ? null : `/application/list`, GlossaryFetcher, { errorRetryCount: 2 })
    React.useEffect(() => {
    if(appList && appList.data) {
        let tmp_apps = [];
        appList.data.map( object => {
            if(object.id !== id) {
                tmp_apps.push({
                    value: object.id,
                    text: object.name
                })
            }
        })
        setDataApps(tmp_apps);
    }
    }, [appList, id])



    const [errors, setError] = useState({})

    const { data : dataFlow, errorDataFlow } = useSWR(flow && flow.id ? `/data-flow/details/${flow.id}` : null, GlossaryFetcher, { errorRetryCount: 2 })

    React.useEffect(() => {
            if(dataFlow && dataFlow.data) {
                setState({
                    id: dataFlow.data.id,
                    direction: dataFlow.data.sourceApplicationId === id ? "out" : "in",
                    periodicity: dataFlow.data.periodicity,
                    source: dataFlow.data.sourceApplicationId === id ? dataFlow.data.targetApplicationId : dataFlow.data.sourceApplicationId,
                    status: dataFlow.data.status,
                    //docLink: dataFlow.data.docLink,
                    //technology: dataFlow.data.technology,
                })}
    }
        , [dataFlow, flow])

    const formSchema = Yup.object().shape({
        periodicity: Yup.string().required(),
        status: Yup.string().required(),
        direction: Yup.string().required(),
        source: Yup.string().required(),
    });

    const handleInputChange = (e, {name, value}) => {

        if (errors[name] === true) {
            setError( errors => {
                return {
                    ...errors,
                    [name]: false
                }
            })
        }

        setState( state => {
            return {
                ...state,
                [name]: value
            }
        })

    }

    const handleOnSubmit = () => {

        setError({})

        let dataToSave = {};
        dataToSave.periodicity = state.periodicity;
        dataToSave.status = state.status;
        dataToSave.direction = state.direction;
        dataToSave.source = state.source;
        //dataToSave.docLink = state.docLink;
        dataToSave.id = state.id ? state.id : null;

        if(state.direction === "in") {
            dataToSave.sourceApplicationId = state.source;
            dataToSave.targetApplicationId = id;
        }
        else {
            dataToSave.sourceApplicationId = id;
            dataToSave.targetApplicationId = state.source;
        }

        formSchema.validate(dataToSave, {abortEarly: false}).then( data => {

            /*setState( state => {
                return {
                    ...state,
                }
            })*/


            // Callback
            if (typeof onSubmit === 'function') {
                const reply = GlossarySave(`/data-flow/save`, data)

                reply.then(res => {
                    if (res.success === true) {
                        setState(initialState);
                        setError({})
                        onSubmit()
                        //setTimeout(function() {console.log(state, initialState, data)}, 1000)

                        //mutate(`/data-flow/details/${flow.id}`)
                    }
                }).catch( error => {
                    const errorFields = {}

                    /*for (const [key, value] of Object.entries(error.response.data.messages)) {
                        errorFields[key] = getApiResponseErrorMessage({key: value, prefix: fieldNames[key]})
                    }*/

                    setError( err => {
                        return {
                            ...err,
                            ...errorFields
                        }
                    })
                    setState( state => {
                        return {
                            ...state,
                            dialogLoading: false,
                        }
                    })
                })
            }

        }).catch( errors => {

            console.log(errors)

            const errorFields = {}

            errors.inner.forEach( error => errorFields[error.path] = error.message.replace(error.path, fieldNames[error.path]))//true)

            setError( err => {
                return {
                    ...err,
                    ...errorFields
                }
            })

        })

    }

    const _onClose = () => {
        setError({})
        setState(initialState);
        onClose()
    }

    if(loadElements.current === false) {
        loadElements.current = true;
    }

    return (
        <Dialog open={open} onClose={_onClose} closeOnEscape={false} closeOnDimmerClick={false}>

            <Form onSubmit={handleOnSubmit} loading={loading}>

                <Dialog.Header>
                    {state.id ? "Edit Data Flow" : "Add new Data Flow"}
                </Dialog.Header>

                <Dialog.Content>

                    <Form.Group widths="equal">

                        <Form.Field>

                            <Form.Select
                                name="direction"
                                label="Flow Direction"
                                options={directions}
                                error={errors.direction}
                                placeholder={"Select flow direction"}
                                value={state.direction}
                                onChange={handleInputChange}
                                icon={"chevron down"}
                            />

                            <br />

                            <Form.Select
                                name="periodicity"
                                label="Periodicity"
                                options={periods}
                                error={errors.periodicity}
                                placeholder={"Select periodicity"}
                                value={state.periodicity}
                                onChange={handleInputChange}
                                icon={"chevron down"}
                            />

                            <br />

                            {dataApps && <Form.Select
                                name="source"
                                label={state.direction === "in" ? "Source Application" : ( state.direction === "out" ? "Target Application" : "Source / Target Application")}
                                options={dataApps}
                                search
                                error={errors.source}
                                placeholder={"Select Application"}
                                value={state.source}
                                onChange={handleInputChange}
                                icon={"chevron down"}
                            />}

                            <br />

                            <Form.Select
                                name="status"
                                label="Status"
                                options={statuses}
                                error={errors.status}
                                placeholder={"Select Status"}
                                value={state.status}
                                onChange={handleInputChange}
                                icon={"chevron down"}
                            />

                            <br />

                            {/*<Form.Input
                                name="docLink"
                                label={fieldNames.docLink}
                                onChange={handleInputChange}
                                value={state.docLink ? state.docLink : ''}
                            />

                            <br />

                            <Form.Input
                                name="technology"
                                label={fieldNames.technology}
                                onChange={handleInputChange}
                                value={state.technology ? state.technology : ''}
                            />*/}

                        </Form.Field>

                    </Form.Group>

                </Dialog.Content>

                <Dialog.Actions>
                    <Button type="submit" primary>
                        Submit
                    </Button>
                    <Button onClick={_onClose}>
                        Close
                    </Button>
                </Dialog.Actions>

            </Form>
        </Dialog>
    )

}


export default AppDataFlow